export const userType = ["admin", "student"];
